import logger from 'src/utils/logger';
import { toCamel } from 'src/utils/core/word';
import i18next from 'i18next';

export const parseErrors = ({
  graphQLErrors = [],
  networkError,
  message: errorMessage,
}) => {
  const errors = graphQLErrors.map(({ message, locations, path, extensions }) => {
    logger.error(
      `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}, Code: ${extensions.code}`,
    );
    if (extensions && extensions.code === 'INTERNAL_SERVER_ERROR') {
      return i18next.t('INTERNAL_SERVER_ERROR');
    }
    return message;
  });

  if (networkError) errors.push(networkError.message);
  if (errorMessage && !errors.length) errors.push(errorMessage);

  return errors;
};

export const parseFormErrors = error => {
  const allErrors = (error.graphQLErrors || []).map(
    ge => ge.extensions.errors || { general: [ge.message] },
  );
  return allErrors.reduce((acct, errorsObject) => {
    const fieldErrors = Object.keys(errorsObject).reduce((fAcct, key) => {
      const fErrors = (errorsObject[key] || []).join('. ');
      return { ...fAcct, [toCamel(key)]: fErrors };
    }, {});
    return { ...acct, ...fieldErrors };
  }, {});
};
